/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invoice_Misa_Template_SyncInputs */

const vi_invoice_misa_template_sync = /** @type {(inputs: Invoice_Misa_Template_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Làm mới mẫu từ MISA`)
};

/**

* @param {Invoice_Misa_Template_SyncInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const invoice_misa_template_sync = /** @type {((inputs?: Invoice_Misa_Template_SyncInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invoice_Misa_Template_SyncInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_invoice_misa_template_sync(inputs)
});